import React, {Component} from 'react';
import Calendar from "../DatePicker/DatePicker";
import InputMask from 'react-input-mask';
import SubInputs from '../SubInputs/SubInputs';
import ReCaptcha from '../ReCaptcha/';
import SearchAdress from '../SearchAdress/SearchAdress';
import moment from 'moment';

import backImage from '../img/back.png';
import closeGreen from '../img/double-upGreen.svg';
import openGreen from '../img/double-downGreen.svg';
import closeOrange from '../img/double-upOrange.svg';
import openOrange from '../img/double-downOrange.svg';
import calendarGreen from '../img/calendarGreen.svg';
import calendarOrange from '../img/calendarOrange.svg';
import gpsGreen from '../img/map-markerGreen.svg';
import gpsOrange from '../img/map-markerOrange.svg';
import checkCircleStart from '../img/checkCircleStart.svg';
import checkCircleStartGreen from '../img/checkCircleStartGreen.svg';
import checkCircleStartOrange from '../img/checkCircleStartOrange.svg';
import checkCircleEnd from '../img/checkCircleEnd.svg';
import checkCircleEndGreen from '../img/checkCircleEndGreen.svg';
import checkCircleEndOrange from '../img/checkCircleEndOrange.svg';

import './AddForm.css';

let lastMaskInfo

class AddForm extends Component {
    REGEXP = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/;

    MAX_PHONE_NUMBER_LENGTH = 17;

    MAX_KEYWORDS_AMOUNT = 10;

    state = {
        result: {},
        selectInput: "",
        showSelectEmpty: true,
        secretCode: "",
        findDate: Date.now(),
        info: "",
        maskInfo: "",
        money: "",
        phoneNumber: "",
        email: "",
        keyWord: "",
        findPlace: "",
        checkbox: true,
        importantWord: "",
        importantWordArr: [],
        photo: "",
        imagePreviewUrl: "",
        value: "",
        startDate: new Date(),
        birthDate: new Date(473400000000),
        boxShadow: "",
        closeStep1: true,
        closeStep2: true,
        closeStep3: true,
        variable: '',
        noEmailValidation: false,
        noPhoneValidation: false,
        additionalItem1: "",
        additionalItem2: "",
        additionalItem3: "",
        additionalItem4: "",
        isReCaptchaValid: false,
        mask: require('../config.json')
    };

    handleChangeState = (event) => {
        if (!this.state.selectInput) {
            this.setState({
                [event.target.name]: event.target.value,
                showSelectEmpty: false
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    };

    handleChangeStateEmail = (event) => {
            this.setState({
                [event.target.name]: event.target.value !== ' ' ? event.target.value : ''
            })
    };

    emailValidation = (event) => {
        if (event.target.name === 'email') {
            this.setState({
                noEmailValidation: false
            })
        } else if (this.state.email === '' || (this.state.email && this.state.email.match(this.REGEXP))) {
            this.setState({
                noEmailValidation: false
            })
        } else {
            this.setState({
                noEmailValidation: true
            })
        }
    }

    phoneValidation = (event) => {
        if (event.target.name === 'phoneNumber') {
            this.setState({
                noPhoneValidation: false,
            })
        } else if (this.state.phoneNumber && this.state.phoneNumber.length !== this.MAX_PHONE_NUMBER_LENGTH) {
            this.setState({
                noPhoneValidation: true,
            })
        } else {
            this.setState({
                noPhoneValidation: false,
            })
        }
    }

    handleChangeStatePhone = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    handleChangeStateOfAdditionalWithValidation = (event) => {
        let text = event.target.value
        let numbers = text.match(/\d/);
        let lastLetter = '';
        let plateNumberMaskLetter = '';
        let plateNumberMaskNumber = '';
        text && (lastLetter = [...event.target.value].reverse()[0])
        text && (plateNumberMaskLetter = lastLetter.match(/[а-яА-Яa-zA-Z]/gi));
        text && (plateNumberMaskNumber = lastLetter.match(/\d/gi));
        if (text !== ' ') {
            if ((this.state.variable === 'plateNumber' && event.target.name === 'additionalItem1') || (this.state.variable === 'techPassport' && event.target.name === 'additionalItem2')) {
                if (text.length <= this.MAX_KEYWORDS_AMOUNT && (plateNumberMaskNumber || plateNumberMaskLetter || text === '' || lastLetter === '-' || lastLetter === ' ')) {
                    this.setState({
                        [event.target.name]: text
                    })
                }
            } else if (event.target.name === "importantWord") {
                if (text.length <= 25) {
                    this.setState({
                        [event.target.name]: text
                    })
                }
            } else if (this.state.variable === 'techPassport' && event.target.name === 'additionalItem1' && !numbers) {
                this.setState({
                    [event.target.name]: text
                })
            } else if (event.target.name === "info") {
                this.setState({
                    [event.target.name]: text,
                })
            } else if (event.target.name === "money") {
                if (text.length <= 6 && (plateNumberMaskNumber || text === '')) {
                    this.setState({
                        [event.target.name]: text,
                    })
                }
            } else if (this.state.variable === "keys" || this.state.variable === "purse" || this.state.variable === "other") {
                this.setState({
                    [event.target.name]: text
                })
            } else if (!numbers) {
                this.setState({
                    [event.target.name]: text
                })
            }
        }
    }

    handleChangeStateOfAdditional = (event) => {
        this.setState({
            importantWordArr: [],
            variable: event.target.value,
            info: "",
            additionalItem1: '',
            additionalItem2: '',
            additionalItem3: '',
            additionalItem4: '',
        })
    };

    deleteItem = (event) => {
        let id = event.target.id;
        let newArr = this.state.importantWordArr.filter(obj => +(obj.id) !== +id)
        this.setState({
            importantWordArr: [...newArr],
        })
    }

    toggleOfState = (someName) => {
        this.setState(prev => ({
            [someName]: !prev[someName]
        }))
    }

    handleImageChange = (event, del = '') => {
        event.preventDefault();
        let fileInput = event.target.files
        let reader = new FileReader();
        if (fileInput && !!Object.keys(fileInput).length) {
            reader.onloadend = () => {
                this.setState({
                    photo: fileInput[0],
                    imagePreviewUrl: reader.result
                });
            }
            reader.readAsDataURL(fileInput[0])
        }
        if (del) {
            let file = document.getElementById('photoFile')
            file.value = ''
            this.setState({
                photo: '',
                imagePreviewUrl: ''
            });
        }
    }

    handleChangeDate = (date, component) => {
        this.setState({
            [component]: date
        });
    }

    beforeMaskedValueChange = (newState, oldState, userInput) => {
        let {value} = newState;
        let selection = newState.selection;
        let cursorPosition = selection ? selection.start : null;
        // keep minus if entered by user
        if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
            if (cursorPosition === value.length) {
                cursorPosition--;
                selection = {start: cursorPosition, end: cursorPosition};
            }
            value = value.slice(0, -1);
        }
        return {
            value,
            selection
        };
    };

    validateCaptcha = (token) => {
        this.setState({
            isReCaptchaValid: !!token
        });
    };

    pushToArr = (event, arr) => {
        if (event.keyCode === 13) {
            if (this.state.importantWord) {
                if (this.state.importantWordArr.length < this.MAX_KEYWORDS_AMOUNT) {
                    if (!this.state.importantWordArr.filter(obj => obj.word === this.state.importantWord).length && this.state.importantWord.length > 1) {
                        let obj = {
                            word: this.state.importantWord,
                            id: Date.now(),
                        };
                        let newArr = [...this.state[arr], obj];
                        this.setState({
                            [arr]: [...newArr],
                            importantWord: '',
                        })
                    }
                }
            }
        }
    };

    importantWordFromStep1 = () => {
        if ((this.state.variable === 'passport' || this.state.variable === 'driverLicense' || this.state.variable === 'kievCard')) {
            if (this.state.additionalItem1) {
                if (!this.state.importantWordArr.find(obj => this.state.additionalItem1 === obj.word)) {
                    let newArr = this.state.importantWordArr
                    if (this.state.importantWordArr.find(obj => obj.item && obj.item === 'item1')) {
                        newArr = newArr.filter(obj => obj.item && obj.item !== 'item1')
                    }
                    let obj = {
                        word: this.state.additionalItem1,
                        item: 'item1',
                        id: Date.now(),
                    };
                    newArr = [obj, ...newArr];
                    this.setState({
                        importantWordArr: [...newArr],
                    })
                }
            } else if (this.state.importantWordArr.find(obj => obj.item && obj.item === 'item1')) {
                let newArr = this.state.importantWordArr.filter(obj => obj.item && obj.item !== 'item1')
                this.setState({
                    importantWordArr: [...newArr],
                })
            }
            if (this.state.additionalItem2) {
                if (!this.state.importantWordArr.find(obj => this.state.additionalItem2 === obj.word && obj.item === 'item2')) {
                    let newArr = this.state.importantWordArr
                    if (this.state.importantWordArr.find(obj => obj.item === 'item2')) {
                        newArr = newArr.filter(obj => obj.item !== 'item2')
                    }
                    let obj = {
                        word: this.state.additionalItem2,
                        item: 'item2',
                        id: Date.now(),
                    };
                    newArr = [...newArr, obj];
                    this.setState({
                        importantWordArr: [...newArr],
                    })
                }
            } else if (this.state.importantWordArr.find(obj => obj.item && obj.item === 'item2')) {
                let newArr = this.state.importantWordArr.filter(obj => obj.item && obj.item !== 'item2')
                this.setState({
                    importantWordArr: [...newArr],
                })
            }

        }
    }

    upFirstLetter = (str = '') => {
        if (str) {
            let firstLetter = [...str][0].toUpperCase()
            let newStr = [firstLetter, ...str.substr(1)].join("")
            return newStr
        }
    }

    maskInfoState = () => {
        let maskInfo = ''
        let mask = this.state.mask
        let lang = this.props.currentLang
        let selectInput = this.state.selectInput
        let item1 = (selectInput === 'purse' || selectInput === 'plateNumber' || selectInput === 'keys') && !!this.state.additionalItem1 ? '' : this.state.additionalItem1
        let item2 = (selectInput === 'passport' || selectInput === 'driverLicense' || selectInput === 'kievCard') && !!this.state.additionalItem2  ? this.state.additionalItem2 : ''
        let date = moment(this.state.startDate).format('DD.MM.YYYY')
        let type = (this.props.lostProps && 'lost') || (this.props.findProps && 'found')
        if (this.state.selectInput && this.state.additionalItem1) {
            maskInfo = `${mask[lang][type][selectInput]} ${item1} ${item2} ${date}`
        }
        if (maskInfo !== lastMaskInfo) {
            if (this.state.info && !lastMaskInfo) {
                this.setState({
                    info: `${maskInfo} ${this.state.info}`
                })
            } else {
                this.setState({
                    info: `${maskInfo} `
                })
            }
            lastMaskInfo = maskInfo
        }
    }


    boxShadow = (event) => {
        this.setState({
            boxShadow: event.target.dataset.name
        })
    };

    sendButtonActivity = () => {
        if (
            this.state.isReCaptchaValid &&
            this.state.additionalItem1 &&
            this.state.info &&
            this.state.phoneNumber.length === this.MAX_PHONE_NUMBER_LENGTH &&
            this.state.email.match(this.REGEXP) &&
            this.state.checkbox) {
            return ""
        } else {
            return 'disabled'
        }
    }

    render() {
        return (
            <div className="addForm-Wrapper"
                 onClick={(event) => {
                     this.boxShadow(event);
                     this.emailValidation(event);
                     this.phoneValidation(event);
                     this.importantWordFromStep1();
                 }}>
                <div className="checkLine">
                    <div className="checkLine-first">
                        <div
                            className={this.state.additionalItem1 ? `checkLineImg-wrapper ${this.props.backGroundColorProps}` : 'checkLineImg-wrapper'}>
                            <img className="checkLine-firstBefore"
                                 src={this.state.additionalItem1 ? (this.props.findProps && checkCircleStartGreen) || (this.props.lostProps && checkCircleStartOrange) : checkCircleStart}
                                 alt=""/>
                            <img className="checkLine-firstAfter"
                                 src={this.state.additionalItem1 ? (this.props.findProps && checkCircleEndGreen) || (this.props.lostProps && checkCircleEndOrange) : checkCircleEnd}
                                 alt=""/>
                        </div>
                        {this.props.langProps.checkLine.text1}
                    </div>
                    <div className="checkLine-second">
                        <div
                            className={this.state.info ? `checkLineImg-wrapper ${this.props.backGroundColorProps}` : 'checkLineImg-wrapper'}>
                            <img className="checkLine-firstAfter"
                                 src={this.state.info ? (this.props.findProps && checkCircleEndGreen) || (this.props.lostProps && checkCircleEndOrange) : checkCircleEnd}
                                 alt=""/>
                        </div>
                        {this.props.langProps.checkLine.text2}
                    </div>
                    <div className="checkLine-third">
                        <div
                            className={this.state.phoneNumber && this.state.email ? `checkLineImg-wrapper ${this.props.backGroundColorProps}` : 'checkLineImg-wrapper'}>
                            <img className="checkLine-firstAfter"
                                 src={this.state.phoneNumber && this.state.email ? (this.props.findProps && checkCircleEndGreen) || (this.props.lostProps && checkCircleEndOrange) : checkCircleEnd}
                                 alt=""/>
                        </div>
                        {this.props.langProps.checkLine.text3}
                    </div>
                </div>
                <div className={`checkLineMobile ${this.props.backGroundColorProps}`}></div>
                <form
                    action="/complete.php"
                    name="form"
                    method="POST"
                    autoComplete="off"
                    className="addFormSteps-wrapper"
                    acceptCharset="UTF-8"
                    encType="multipart/form-data"
                >

                    <input 
                        type="hidden" 
                        name="coordinates" 
                        value={`${this.props.markerLat}, ${this.props.markerLng}`} 
                    />

                    <input 
                        type="hidden" 
                        name="type" 
                        value={this.props.lostProps && 'lost' || this.props.findProps && 'found'} 
                    />

                    <input 
                        type="hidden" 
                        name="meta" 
                        value={this.state.importantWordArr.map(obj => obj.word)} 
                    />

                    <input 
                        type="hidden" 
                        name="action" 
                        value="add"
                    />

                    <input 
                        type="hidden" 
                        name="date" 
                        value={moment(this.state.startDate).format('YYYY-MM-DD')} 
                    />

                    <input 
                        type="hidden" 
                        name="secret" 
                        value={document.getElementById('secretCodeId') ? document.getElementById('secretCodeId').textContent : ''} 
                    />

                    <input
                        type="hidden"
                        name="selectedInput"
                        value={document.getElementById("selectInput")? document.getElementById("selectInput").options[document.getElementById("selectInput").selectedIndex].text : ''}
                    />

                    <input 
                        type="hidden"
                        name="birthDate"
                        value={moment(this.state.birthDate).format('YYYY-MM-DD')}
                    />

                    <div className='inputsWrapper'>
                        <span
                            className={`formStep ${this.props.backGroundColorProps}`}>{this.props.langProps.step1.titleStep1}</span>
                        {this.state.closeStep1 &&
                        <div className='formStep-Box'>
                            <div className='formStep-item'>
                                <div className='formStep-inputWrapper'>
                                    <select name="selectInput"
                                            id="selectInput"
                                            className={this.state.boxShadow === 'selectStep1' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                                            data-name="selectStep1" data-option='d'
                                            defaultValue={this.state.selectInput}
                                            onChange={event => {
                                                this.handleChangeState(event);
                                                this.handleChangeStateOfAdditional(event);
                                            }}>
                                        {this.state.showSelectEmpty &&
                                        <option value="">{this.props.langProps.step1.emptyItem}</option>}
                                        <option
                                            value={this.props.langProps.step1.selectName1}>{this.props.langProps.step1.passport}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName2}>{this.props.langProps.step1.techPassport}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName3}>{this.props.langProps.step1.driverLicense}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName4}>{this.props.langProps.step1.animal}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName5}>{this.props.langProps.step1.purse}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName6}>{this.props.langProps.step1.keys}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName7}>{this.props.langProps.step1.plateNumber}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName8}>{this.props.langProps.step1.kievCard}</option>
                                        <option
                                            value={this.props.langProps.step1.selectName9}>{this.props.langProps.step1.other}</option>
                                    </select>
                                </div>
                                <span
                                    className="formStep-item__textSelect">{this.props.langProps.step1.selectHeader}</span>
                            </div>
                            {this.state.selectInput && <SubInputs
                                handleChangeFuncProps={(event) => {
                                    this.handleChangeStateOfAdditionalWithValidation(event);
                                }}
                                stateBoxShadowProps={this.state.boxShadow}
                                stateAdditionalItem1Props={this.state.additionalItem1}
                                stateAdditionalItem2Props={this.state.additionalItem2}
                                stateAdditionalItem3Props={this.state.additionalItem3}
                                stateAdditionalItem4Props={this.state.additionalItem4}
                                stateSecretCodeProps={this.state.secretCode}
                                stateVariableProps={this.state.variable}
                                handleChangeAdditionalFuncProps={(event) => this.handleChangeStateOfAdditional(event)}
                                objSubProps={this.props.langProps.subMenu}
                                handleChangeDateFuncProps={(date) => {
                                    this.handleChangeDate(date, 'birthDate')
                                }}
                                stateBirthDayProps={this.state.birthDate}
                                lostProps={this.props.lostProps}
                                findProps={this.props.findProps}
                                getSecretCode={this.getSecretCode}
                            />}
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <Calendar
                                        classProps={this.state.boxShadow === 'calendar' ? 'calendar formStep-inputBoxShadow' : "calendar"}
                                        dataSetProps={"calendar"}
                                        changeDateFunc={(date) => {
                                            this.handleChangeDate(date, 'startDate')
                                        }}
                                        startDateProps={this.state.startDate}
                                    />
                                    <div className="formStep-calendarImgBox">
                                        <img
                                            src={(this.props.findProps && calendarGreen) || (this.props.lostProps && calendarOrange)}
                                            alt=""
                                            className="formStep-calendarImg"/>
                                    </div>
                                </div>
                                <span
                                    className="formStep-item__text">{(this.props.findProps && this.props.langProps.step1.dateComment) || (this.props.lostProps && this.props.langProps.step1.dateCommentLost)}</span>
                            </div>
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                        <textarea
                                            className={this.state.boxShadow === 'info' ? 'formStep-inputTextArea formStep-inputBoxShadow' : "formStep-inputTextArea"}
                                            data-name="info" name="info"
                                            value={this.state.info}
                                            onChange={event => {
                                                this.handleChangeStateOfAdditionalWithValidation(event);
                                            }}
                                            onClick={this.maskInfoState}
                                            placeholder={this.props.langProps.step1.textAreaPlaceHolder}
                                        />
                                </div>
                                <span
                                    className="formStep-item__textArea">{this.props.langProps.step1.textAreaComment}</span>
                            </div>
                        </div>}
                        <div className={`inputsWrapper-close ${this.props.classTextColorProps}`}
                             onClick={() => this.toggleOfState('closeStep1')}>
                            {this.state.closeStep1 ? this.props.langProps.closeOpenFilter.close : this.props.langProps.closeOpenFilter.open}
                            {this.state.closeStep1 ?
                                <img src={(this.props.findProps && closeGreen) || (this.props.lostProps && closeOrange)}
                                     alt=""
                                     className="inputsWrapper-closeImg"/>
                                : <img src={(this.props.findProps && openGreen) || (this.props.lostProps && openOrange)}
                                       alt=""
                                       className="inputsWrapper-closeImg"/>}
                        </div>
                    </div>
                    <div className='inputsWrapper'>
                        <span
                            className={`formStep ${this.props.backGroundColorProps}`}>{this.props.langProps.step2.titleStep2}</span>
                        {this.state.closeStep2 &&
                        <div className='formStep-Box'>
                            {this.props.lostProps && <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <input
                                        className={this.state.boxShadow === 'money' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                                        data-name="money"
                                        name="money"
                                        value={this.state.money}
                                        onChange={event => this.handleChangeStateOfAdditionalWithValidation(event)}
                                        placeholder={this.props.langProps.step2.moneyPlaceHolder}/>
                                </div>
                                <span
                                    className="formStep-item__text">{this.props.langProps.step2.moneyComment}</span>
                            </div>}
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <InputMask mask="+38(999)999-99-99"
                                               maskChar={null}
                                               defaultValue={this.state.phoneNumber}
                                               onChange={event => {
                                                   this.handleChangeStatePhone(event);
                                               }}
                                               beforeMaskedValueChange={this.beforeMaskedValueChange}
                                               placeholder="+38 (___) ___-__-__"
                                               className={this.state.boxShadow === 'phone' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                                               data-name="phone"
                                               name='phoneNumber'/>
                                </div>
                                <span
                                    className={this.state.noPhoneValidation ? 'formStep-item__text formStep-item__textBackGroundRed' : 'formStep-item__text'}>{this.props.langProps.step2.phoneNumberComment}</span>
                            </div>
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <input
                                        className={this.state.boxShadow === 'email' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                                        data-name="email" type="email"
                                        name="email"
                                        value={this.state.email}
                                        onChange={event => {
                                            this.handleChangeStateEmail(event);
                                        }}
                                        placeholder={this.props.langProps.step2.emailPlaceHolder}
                                    />
                                </div>
                                <span
                                    className={this.state.noEmailValidation ? "formStep-item__text formStep-item__textBackGroundRed" : "formStep-item__text"}>{this.props.langProps.step2.emailComment}</span>
                            </div>
                        </div>}
                        <div className={`inputsWrapper-close ${this.props.classTextColorProps}`}
                             onClick={() => this.toggleOfState('closeStep2')}>
                            {this.state.closeStep2 ? this.props.langProps.closeOpenFilter.close : this.props.langProps.closeOpenFilter.open}
                            {this.state.closeStep2 ?
                                <img src={(this.props.findProps && closeGreen) || (this.props.lostProps && closeOrange)}
                                     alt=""
                                     className="inputsWrapper-closeImg"/>
                                : <img src={(this.props.findProps && openGreen) || (this.props.lostProps && openOrange)}
                                       alt=""
                                       className="inputsWrapper-closeImg"/>}
                        </div>
                    </div>
                    <div className='inputsWrapper'>
                        <span
                            className={`formStep ${this.props.backGroundColorProps}`}>{this.props.langProps.step3.titleStep3}</span>
                        {this.state.closeStep3 &&
                        <div className='formStep-Box'>
                            <div className="formStep-item">
                                <div className="formStep-inputWrapperWords">
                                    <div className="importantWordForm">
                                        {!!this.state.importantWordArr.length && this.state.importantWordArr.map(obj =>
                                            <span
                                                className={`importantWordForm-item ${this.props.backGroundColorProps}`}
                                                onClick={e => this.deleteItem(e)}
                                                key={obj.id + 1000}
                                            >{obj.word}
                                                <img
                                                    id={obj.id}
                                                    className='formStep-imgBack'
                                                    src={backImage}
                                                    alt=""/></span>)}
                                        <input
                                            className={this.state.boxShadow === 'importantWord' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                                            data-name="importantWord"
                                            name="importantWord"
                                            value={this.state.importantWord}
                                            onChange={event => this.handleChangeStateOfAdditionalWithValidation(event)}
                                            placeholder={this.props.langProps.step3.importantWordsPlaceHolder}
                                            onKeyDown={event => this.pushToArr(event, 'importantWordArr')}
                                        />
                                    </div>
                                </div>
                                <span
                                    className="formStep-item__text">{this.props.langProps.step3.importantWordsComment}</span>
                            </div>
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <SearchAdress
                                        boxClassProps={'formStep-searchBox'}
                                        inputClassProps={'formStep-input'}
                                        addressProps={this.props.addressProps}
                                        addressArrProps={this.props.addressArrProps}
                                        chooseAddressFuncProps={this.props.chooseAddressFuncProps}
                                        handleChangeFuncProps={this.props.handleChangeFuncProps}
                                        showSubListAddressFunc={this.props.showSubListAddressFunc}
                                        showSubListAddress={this.props.showSubListAddress}/>
                                    <div className='formStep-itemPlaceBox'
                                         onClick={this.props.showMapFuncProps}>
                                        <img
                                            src={(this.props.findProps && gpsGreen) || (this.props.lostProps && gpsOrange)}
                                            alt=""
                                            className="formStep-itemPlaceImg"
                                        />
                                        <span
                                            className={`formStep-itemPlaceText ${this.props.classTextColorProps}`}>{this.props.langProps.step3.gpsImageText}</span>
                                    </div>
                                </div>
                                <span
                                    className="formStep-item__text">{this.props.langProps.step3.findPlaceComment}</span>
                            </div>
                            {this.state.variable !== 'passport' && this.state.variable !== 'driverLicense' && this.state.variable !== 'techPassport' && this.state.variable !== '' &&
                            <div className="formStep-item">
                                <div className="formStep-inputWrapper">
                                    <div className='formStep-input__box'>
                                        <span className={`formStep-inputBtn ${this.props.backGroundColorProps}`}
                                              onClick={() => this.fileInput.click()}>{this.props.langProps.step3.buttonUploadText}</span>
                                        {this.state.photo &&
                                        <span
                                            className='formStep-inputName'>{[...this.state.photo.name].length > 20 ? [...this.state.photo.name].slice(0, 12).join('') + ' ...... ' + [...this.state.photo.name].reverse().slice(0, 8).reverse().join('') : this.state.photo.name}</span>}
                                        {this.state.photo &&
                                        <img className='formStep-imgBack'
                                             onClick={(event) => {
                                                 this.handleImageChange(event, 'deleteFile')
                                             }}
                                             src={backImage} alt=""/>}
                                    </div>
                                    <span>
                                        <input className="formStep-item__makePhoto"
                                               id='photoFile'
                                               name="fileToUpload"
                                               type="file"
                                               onChange={(event) => this.handleImageChange(event)}
                                               ref={fileInput => this.fileInput = fileInput}/></span>
                                </div>
                                <span
                                    className="formStep-item__textUpload">{this.props.langProps.step3.buttonUploadComment}</span>
                            </div>}
                            {this.state.imagePreviewUrl &&
                            <div className="formStep-uploadBox formStep-itemMarginBottom">
                                <img className='uploadFile' src={this.state.imagePreviewUrl} alt=""/>
                            </div>}

                            <ReCaptcha
                                validateCaptcha={this.validateCaptcha}
                            />

                            <div className="formStep-itemCheckBox checkBox-wrapper">
                                <input className='formStep-item__checkbox'
                                       type="checkbox"
                                       defaultChecked="checked"
                                       onChange={(event => this.toggleOfState('checkbox'))}
                                       ref={checkBox => this.checkBox = checkBox}/>
                                <p className='formStep-item__checkboxText'
                                   onClick={() => this.checkBox.click()}>{this.props.langProps.step3.checkBoxText}</p>
                            </div>
                        </div>}
                        <div className={`inputsWrapper-close ${this.props.classTextColorProps}`}
                             onClick={() => this.toggleOfState('closeStep3')}>
                            {this.state.closeStep3 ? this.props.langProps.closeOpenFilter.close : this.props.langProps.closeOpenFilter.open}
                            {this.state.closeStep3 ?
                                <img src={(this.props.findProps && closeGreen) || (this.props.lostProps && closeOrange)}
                                     alt=""
                                     className="inputsWrapper-closeImg"/>
                                : <img src={(this.props.findProps && openGreen) || (this.props.lostProps && openOrange)}
                                       alt=""
                                       className="inputsWrapper-closeImg"/>}
                        </div>
                    </div>
                    <button
                        className={this.sendButtonActivity() ? `addFormSteps-btn ${this.props.backGroundColorProps} addFormSteps-btnOpacity` : `addFormSteps-btn ${this.props.backGroundColorProps}`}
                        id="sendFormButton"
                        type="submit"
                        disabled={this.sendButtonActivity()}>

                        {this.props.langProps.sendButton}
                    </button>
                </form>
            </div>
        );
    }
}

export default AddForm;
